'use strict';

const Relay = require('react-relay/classic');
const SV = require('server-vars');
const { getBuyerToken } = require('dibs-cookie-jar');
const qs = require('qs');

/**
 * Custom Network Layer that rebuilds the Uri for each GraphQL call in order to append buyer token upon login
 */
class CustomNetworkLayer extends Relay.DefaultNetworkLayer {
    constructor(uri, init) {
        let getUri;

        if (typeof uri === 'function') {
            getUri = uri;
            uri = getUri();
        }

        super(uri, init);

        this.getUri = (getUri || this.getUri).bind(this);
    }

    getUri() {
        return this._uri;
    }

    sendQueries() {
        this._uri = this.getUri();
        return Relay.DefaultNetworkLayer.prototype.sendQueries.call(this, ...arguments);
    }

    sendMutation() {
        this._uri = this.getUri();
        return Relay.DefaultNetworkLayer.prototype.sendMutation.call(this, ...arguments);
    }
}

module.exports = () =>
    new CustomNetworkLayer(
        () => {
            const { debugGraphQL } = qs.parse(window.location.search.replace(/(^\?)/, ''));
            const locale = SV.get('locale');
            const queryParams = Object.assign(
                getBuyerToken(document.cookie),
                locale ? { locale } : {},
                debugGraphQL === 'true' ? { debug: 'true' } : {}
            );

            return `/soa/graphql/?${qs.stringify(queryParams)}`;
        },
        { fetchTimeout: 120000 }
    );



// WEBPACK FOOTER //
// ./assets/js/global/relayClientNetworkLayer.es.js